export default {
  name: 'table-loading',
  props: {
    data: ""
  },
  data() {
    return {
    }
  },

  components: {

  },
  create() {
  },

  methods: {

  }
}